import { useEffect, useRef } from "react";
import {
  requestPushPermission,
  listenForForegroundMessages,
} from "../firebase/pushNotifications";

const usePushNotifications = (enabled = true, onMessageReceived) => {
  const callbackRef = useRef(onMessageReceived);

  useEffect(() => {
    callbackRef.current = onMessageReceived;
  }, [onMessageReceived]);

  useEffect(() => {
    if (!enabled) return undefined;

    let unsubscribe;
    let cancelled = false;

    (async () => {
      await requestPushPermission();
      if (cancelled) return;

      unsubscribe = await listenForForegroundMessages((payload) => {
        callbackRef.current?.(payload);
      });
    })();

    return () => {
      cancelled = true;
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, [enabled]);
};

export default usePushNotifications;